module.exports = __webpack_public_path__ + "img/Slideshows-espace-client-permanents4.f2cfe68e.png";